import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './CheckboxSimple.less'

class CheckboxSimple extends Component {
  state = {
    isChecked: false,
  }

  toggleCheckboxChange = () => {
    const { handleCheckboxChange, data } = this.props
    this.setState(({ isChecked }) => (
      {
        isChecked: !isChecked,
      }
    ))
    handleCheckboxChange(data)
  }

  render() {
    const { label } = this.props
    const { isChecked } = this.state

    return (
      <div className={style.checkbox}>
        <input
          type="checkbox"
          value={label}
          id={label}
          checked={isChecked}
          onChange={this.toggleCheckboxChange}
        />
        <label htmlFor={label}>
          {label}
        </label>
      </div>
    )
  }
}

CheckboxSimple.propTypes = {
  label: PropTypes.element.isRequired,
  data: PropTypes.string.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  setClick: PropTypes.object,
  onRef: PropTypes.func,
}

export default CheckboxSimple
